/**
 * @file 阈值提醒弹窗组件
 */
<template>
  <div class="c-thresholdReminder">
    <plv-dialog
      :visible="visible"
      title="阈值提醒"
      show-footer-btn
      :close-on-click-mask="false"
      :closable="false"
      @confirm="handleSubmit"
      @cancel="handleClose"
      @close="handleClose"
    >
      <plv-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="120px"
      >
        <plv-form-item label="剩余金额（元）" tips-text="设置为0则不触发提醒" prop="balance">
          <plv-input-number
            v-model="form.balance"
            size="medium"
            placeholder="请输入剩余金额（元）"
            :en-length="1"
          />
        </plv-form-item>
        <plv-form-item label="剩余观看分钟数" tips-text="设置为0则不触发提醒" prop="minutes">
          <plv-input-number
            v-model="form.minutes"
            size="medium"
            placeholder="请输入剩余观看分钟数"
            :en-length="1"
          />
        </plv-form-item>
        <plv-form-item label="提醒手机号" tips-text="可以在联系人处修改" prop="phone">
          <plv-input v-model="form.phone" size="medium" placeholder="请输入提醒手机号" />
        </plv-form-item>
      </plv-form>
    </plv-dialog>
  </div>
</template>

<script>
import { defaultFormRules } from '@/utils/type';
import dialogMixin from '@/mixins/dialog';
export default {
  mixins: [dialogMixin],
  data() {
    return {
      form: {
        balance: '',
        minutes: '',
        phone: ''
      },
      rules: Object.assign(defaultFormRules, {
        balance: {
          type: 'number',
          message: '请输入剩余金额',
          required: true,
          min: 0
        },
        minutes: {
          type: 'number',
          message: '请输入剩余观看分钟数',
          required: true,
          min: 0
        },
      })
    };
  },
  created() {
    this.getThreshold();
  },
  methods: {
    async getThreshold() {
      const res = await this.$store.dispatch('account/getThreshold');
      if (res) {
        this.form = res;
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        await this.$store.dispatch('account/saveThreshold', this.form);
        this.$toast.success('设置成功');
        this.handleClose();
      } catch {}
    },
  }
};
</script>
